<script lang="ts">
import { CouponInfo, CouponButtonType } from '@tencent/wphk-act-base-ui';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { CouponVersion, ICashCouponInfo } from './type';
import { language } from '@tencent/ppd-base-libs';
import { adaptCashCouponInfo } from './business/coupon';
import { initLang } from './i18n/index';
import { QryAndFormatCouponItem, UtilsTypes } from '@tencent/wphk-act-base-types';
// 基本优惠券
@Component
export default class BasicCoupon extends Vue {
  /** 如果需要强制设置某语言，则传入lang；否则默认使用系统语言 */
  @Prop() lang?: UtilsTypes.LanguageTypeEnum;
  /** 券数据 - 旧数据源， originalCouponInfo 和 couponInfo 二选一 */
  @Prop() originalCouponInfo?: ICashCouponInfo;
  /** 券数据 - 新数据源， coriginalCouponInfo 和 couponInfo 二选一， 为调用qryAndFormatCouponList后生产的券 */
  @Prop() couponInfo?: QryAndFormatCouponItem;
  /** 券数据 - 用于覆盖券 ui 属性 */
  @Prop() extraParams?: CouponInfo;

  get couponLang() {
    return this.lang || language.getLanguage();
  }

  get formattedCouponInfo() {
    return adaptCashCouponInfo({
      couponLang: this.couponLang,
      coupon: this.originalCouponInfo,
      formattedCoupon: this.couponInfo,
      extraParams: this.extraParams,
      version: CouponVersion.new,
    });
  }

  /** 点击券按钮 */
  @Emit('btnClick')
  btnClick() {
    // @ts-ignore
    if (this.formattedCouponInfo.buttonType === CouponButtonType.disabled) return;
    return this.formattedCouponInfo;
  }

  /** 点击券面 */
  @Emit('couponClick')
  couponClick() {}

  created() {
    /** 初始化语言包 */
    initLang(this.couponLang);
  }
}
</script>
